module.exports = __webpack_public_path__ + "static/media/img35.5c414649.jpg";